export default __webpack_public_path__ + "static/media/b9.7918d33a.jpg";